exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".work-summary .table{font-size:.7em}.work-summary tr:hover{background-color:#f5f5f5}.work-summary .work-summary__title{padding-left:10px}.work-summary .work-summary__title select{width:170px;display:inline}.work-summary .work-summary__title .col-sm-6{width:auto;display:inline-block;flex:none}.work-summary .work-summary__title h3{text-align:center}.work-summary .work-summary__title .row{margin:0}.work-summary .horizontal-table{width:100%;display:table}.work-summary table th.work-summary-month{width:auto;text-align:left}.work-summary .weekend{background-color:hsla(0,8%,88%,.49)}.work-summary .insufficient-day{background-color:hsla(0,57%,86%,.85)}.work-summary .insufficient-month{background-color:rgba(250,90,0,.45)}.work-summary .insufficient{color:blue}.work-summary .archived{color:sienna}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7c86f03a!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/WorkSummary.vue
// module id = 226
// module chunks = 0